import api from './axios';

// Auth
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  me: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout'),
  updatePassword: (currentPassword, newPassword) => api.put('/auth/password', { currentPassword, newPassword }),
  refresh: (refreshToken) => api.post('/auth/refresh', { refreshToken }),
  setPassword: (token, password) => api.post('/auth/set-password', { token, password }),
};

// CRUD générique
const crud = (resource) => ({
  getAll: (params) => api.get(`/${resource}`, { params }),
  getOne: (id) => api.get(`/${resource}/${id}`),
  create: (data) => api.post(`/${resource}`, data),
  update: (id, data) => api.put(`/${resource}/${id}`, data),
  remove: (id) => api.delete(`/${resource}/${id}`),
});

export const revendeursAPI = crud('revendeurs');
export const clientsAPI = crud('clients');
export const projetsAPI = {
  ...crud('projets'),
  mesProjetsIoT: () => api.get('/projets/mes-projets-iot'),
};
export const noeudsAPI = {
  ...crud('noeuds'),
  getBySn: (sn) => api.get(`/noeuds/by-sn/${sn}`),
  getSensorData: (id, params) => api.get(`/noeuds/${id}/data`, { params }),
  getDependencies: (id) => api.get(`/noeuds/${id}/dependencies`),
  getDisponibles: (params) => api.get('/noeuds/disponibles', { params }),
  retourStock: (id) => api.put(`/noeuds/${id}/retour-stock`),
  command: (id, data) => api.post(`/noeuds/${id}/command`, data),
  commandCheck: (id, action) => api.get(`/noeuds/${id}/command/check`, { params: { action } }),
  relatedRules: (id) => api.get(`/noeuds/${id}/related-rules`),
  predict: (id, value) => api.post(`/noeuds/${id}/predict`, { value }),
};
export const chantiersAPI = {
  ...crud('chantiers'),
  remove: (id, keepNoeuds = false) => api.delete(`/chantiers/${id}?keepNoeuds=${keepNoeuds}`),
};
export const abonnementsAPI = crud('abonnements');
export const membresAPI = crud('membres');
export const evenementsAPI = {
  ...crud('evenements'),
  toggle: (id) => api.put(`/evenements/${id}/toggle`),
  checkConflicts: (data) => api.post('/evenements/check-conflicts', data),
};
export const automatisationsAPI = {
  ...crud('automatisations'),
  toggle: (id) => api.put(`/automatisations/${id}/toggle`),
  restart: (id) => api.put(`/automatisations/${id}/restart`),
  checkConflicts: (data) => api.post('/automatisations/check-conflicts', data),
  byActionneurs: (params) => api.get('/automatisations/by-actionneurs', { params }),
};
export const fonctionsAPI = {
  ...crud('fonctions'),
  toggle: (id) => api.put(`/fonctions/${id}/toggle`),
};
export const actionLogsAPI = {
  getAll: (params) => api.get('/action-logs', { params }),
  stats: () => api.get('/action-logs/stats'),
};
export const alertesAPI = {
  getAll: (params) => api.get('/alertes', { params }),
  markAllRead: () => api.put('/alertes/mark-all-read'),
  markRead: (id) => api.put(`/alertes/${id}/mark-read`),
  countNew: () => api.get('/alertes/count-new'),
};
export const parametresAPI = {
  get: () => api.get('/parametres'),
  update: (data) => api.put('/parametres', data),
};
export const dashboardAPI = {
  stats: () => api.get('/dashboard/stats'),
  mapData: () => api.get('/dashboard/map-data'),
  chartsAbonnements: () => api.get('/dashboard/charts/abonnements'),
  chartsStatut: () => api.get('/dashboard/charts/statut'),
  topRevendeurs: () => api.get('/dashboard/top-revendeurs'),
  alertesRecentes: () => api.get('/dashboard/alertes-recentes'),
};
export const usersAPI = {
  ...crud('users'),
  resendInvitation: (id) => api.post(`/users/${id}/resend-invitation`),
};
export const cascadeAPI = {
  revendeurs: () => api.get('/cascade/revendeurs'),
  clients: (revendeur) => api.get('/cascade/clients', { params: revendeur ? { revendeur } : {} }),
  projets: (client, revendeur) => api.get('/cascade/projets', { params: { ...(client && { client }), ...(revendeur && { revendeur }) } }),
  noeuds: (projet, categorie) => api.get('/cascade/noeuds', { params: { projet, categorie } }),
};
